import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { DynFormSection } from '../../../common-shared-module/model/dyn-form/dyn-form-section.model';
import { EFormDynamicSectionMetadataService } from './e-form-dynamic-section-metadata.service';
import { SectionMetadata, SectionMetadataRepository } from '../../model/eform/eform-api.model';
import { SectionLayoutMetadata } from '../../model/dyn-form/form-metadata/layout/section-layout.model';

@Injectable({
    providedIn: 'root'
})
export class EFormSectionMetadataService implements SectionMetadataRepository {

    constructor(protected dynSectionMetadata: EFormDynamicSectionMetadataService) { }

    find(section: DynFormSection): Observable<SectionMetadata> {

        //TODO: Check the section type, and choose the correct class to solve the result if it's not a dynamic one.
        return this.dynSectionMetadata.loadSectionMetadata(section.id).pipe(map(r => {
            let sectionMetadata: SectionMetadata = {
                sectionId: section.id,
                identifier: r.id,
                shown: r.shown
                // validForm: null
            }
            return sectionMetadata
        }))

    }

    findMetadata(section: DynFormSection): Observable<SectionLayoutMetadata> {
        return this.dynSectionMetadata.loadSectionMetadata(section.id)
    }

}
